// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { RunOut } from './runOut.zod.ts';

export const RunListOut = zod.object({
  "page": zod.int(),
  "page_size": zod.int(),
  "runs": zod.array(RunOut),
  "total": zod.int()
});

export type RunListOut = zod.input<typeof RunListOut>;
export type RunListOutOutput = zod.output<typeof RunListOut>;
